import { render } from "./Markdown.vue?vue&type=template&id=60c3b561"
import script from "./Markdown.vue?vue&type=script&lang=js"
export * from "./Markdown.vue?vue&type=script&lang=js"

import "./Markdown.vue?vue&type=style&index=0&id=60c3b561&lang=scss"
script.render = render

export default script